export const createMenuItem = (label: string, onClick: () => void) => {
    return {
        label,
        onClick
    }
};